import styled from 'styled-components'
import { default as HeroDefault } from 'src/components/Hero/Default'
import HeroText from 'src/components/Hero/Text'

import MainLayout from '../../layouts/MainLayout'
import { mq, pxToRem, sizes } from '../../theme'

export const Layout = styled(MainLayout)``
export const Top = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(16)};
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(32)};
  }
`
export const Hero = styled(HeroDefault)``
export const _HeroText = styled(HeroText)``
